import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer, { drawerClasses } from "@mui/material/Drawer";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import MenuContent from "./MenuContent";
import { useAuth0 } from "@auth0/auth0-react";

export default function SideMenuMobile({ open, toggleDrawer }) {
  const { user, logout } = useAuth0();

  const handleLogout = () => {
    logout({ returnTo: window.location.origin });
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: "none",
          backgroundColor: "var(--bg-sidebar)",
          color: "var(--text-primary)",
        },
        "& .MuiListItemIcon-root": {
          color: "var(--text-primary)",
        },
        "& .MuiListItemText-primary": {
          color: "var(--text-primary)",
        },
        "& .MuiDivider-root": {
          borderColor: "var(--divider)",
        },
        "& .MuiTypography-root": {
          color: "var(--text-primary)",
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: "70dvw",
          height: "100%",
          pr: 2,
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: "center", flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={user ? user.name : ""}
              src={user?.picture}
              sx={{ width: 24, height: 24 }}
            />
            <Typography component="p" variant="h6">
              {user ? user.name : ""}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent open={open} toggleDrawer={toggleDrawer} />
          <Divider />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<LogoutRoundedIcon />}
            onClick={handleLogout}
            sx={{
              borderColor: "var(--border-medium)",
              color: "var(--text-primary)",
              "&:hover": {
                borderColor: "var(--color-primary)",
                backgroundColor: "var(--menu-item-hover)",
              },
            }}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}
